import produce from 'immer';
import get from 'lodash.get';
import { create } from '../services/api';
import { immerSet } from './util';

const initialState = {};

export const selectAudiograms = episodeId => state =>
  get(state, ['v2', 'audiograms', episodeId], []);

export const RECEIVE_AUDIOGRAMS = 'create/audiogram/RECEIVE_AUDIOGRAMS';

export const audiogramsReceived = ({ episodeId, audiograms }) => ({
  type: RECEIVE_AUDIOGRAMS,
  payload: {
    episodeId,
    audiograms,
  },
});

export const fetchAudiograms = episodeId => dispatch =>
  create.get(`/api-v3/episodes/${episodeId}/audiograms`).then(response => {
    dispatch(
      audiogramsReceived({
        episodeId,
        audiograms: response.body,
      })
    );
  });

export default produce((state, { type, payload }) => {
  // eslint-disable-next-line default-case
  switch (type) {
    case RECEIVE_AUDIOGRAMS: {
      const { episodeId, audiograms } = payload;

      immerSet(state, [episodeId], audiograms);
      break;
    }
  }
}, initialState);
